import Login from "./pages/Auth/Login";
import Home from "./pages/Home";
import { onAuthStateChanged } from "firebase/auth";
import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { auth } from "./config/firebase";
import Users from "./pages/Users";
import Documents from "./pages/Documents";
import UserDetails from "./pages/UserDetails";
import ConfigPayments from "./pages/ConfigPayments";
import AppointmentsList from "./pages/AppointmentsList";
import AppointmentDetails from "./pages/AppointmentDetails";
import ProjectsList from "./pages/ProjectsList";
import CategoriesPage from "./pages/CategoriesPage";
import OffersList from "./pages/OffersList";
import OfferDetails from "./pages/OfferDetails";
import NotificationsPage from "./pages/NotificationsPage";
import PaymentsPage from "./pages/PaymentsPage";
import ReviewsPage from "./pages/ReviewsPage";
import ReportsPage from "./pages/ReportsPage";

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthenticated(!!user);
      setLoaded(true);
    });
    return () => unsubscribe();
  }, []);

  if (!loaded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <img src="/logo.png" alt="Zzigs" className="w-10 h-10 rounded-lg animate-pulse" />
      </div>
    );
  }

  return authenticated ? (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/users" element={<Users />} />
      <Route path="/users/:id" element={<UserDetails />} />
      <Route path="/documents" element={<Documents />} />
      <Route path="/config" element={<ConfigPayments />} />
      <Route path="/projects" element={<ProjectsList />} />
      <Route path="/categories" element={<CategoriesPage />} />
      <Route path="/offers" element={<OffersList />} />
      <Route path="/offers/:id" element={<OfferDetails />} />
      <Route path="/rdv" element={<AppointmentsList />} />
      <Route path="/rdv/:id" element={<AppointmentDetails />} />
      <Route path="/payments" element={<PaymentsPage />} />
      <Route path="/reviews" element={<ReviewsPage />} />
      <Route path="/reports" element={<ReportsPage />} />
      <Route path="/notifications" element={<NotificationsPage />} />

      {/* Route catch-all vers login */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  ) : (
    <Routes>
      <Route path="/" element={<Login />} />
      {/* Pour les inconnues en non auth rediriger aussi vers login */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;